import {initInputStateSwitch} from "./input.state-switch";
import {initDivSiteSubmenu} from "./div.site-submenu";
import {initGetAjaxForm} from "./.get-ajax-form";
import {initAHrefLightbox} from "./a[href*='#lightbox']";
import {initDivMap} from "./div.map";
import {initRange} from './div.range';
import {initShare} from "./div.share";
import {initRangeOne} from "./div.range-one";
import {initSelect} from './div.multiselect';
import {initFavourite} from './a.favourite';
import {initInputs} from './input[type="tel"]';
import {initStrictNameInput} from './input[type="strict-name"]';
import {initButtonMore} from "./a.more";
import {initPageScroll} from './button.scroll-page';
import {initYagaLinks} from './[data-click-yaga]';
import {initYagaButtons} from './[data-yaga]';
import {initLazyImages} from './img.lazy-image';
import {initNotification} from './div.notification';

export const initElements = () => {
	initInputStateSwitch();
	initDivSiteSubmenu();
	initGetAjaxForm();
	initAHrefLightbox();
	initDivMap();
	initRange();
	initShare();
	initRangeOne();
	initSelect();
	initFavourite();
	initInputs();
	initStrictNameInput();
	initButtonMore();
	initPageScroll();
	initYagaLinks();
	initYagaButtons();
	initLazyImages();
	initNotification();
};
